import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { GridModule } from "@features/grid";
import { WidgetChartComponent } from "@main/reporting.v3/widget.chart/components/widget-chart.component";
import { WidgetChartBuilderComponent } from "@main/reporting.v3/widget.chart/components/widget-chart-builder.component";
import { PrimeNgModule } from "@primeng";
import { ChartModule } from "primeng/chart";
import { ColorPickerModule } from "primeng/colorpicker";
import { ReportingCoreModule } from "@main/reporting.v3/reporting-core.module";
import { JsonEditorModule } from "@controls/text-editors/json-editor/json-editor.module";
import { QueryBuilderModule } from "@main/reporting.v3/query-builder/query-builder.module";
import { WidgetChartService } from "@main/reporting.v3/widget.chart/api/widget-chart.service";
import { WidgetChartPdfExportingService } from "@main/reporting.v3/widget.chart/api/widget-chart-pdf-exporting.service";
import { WidgetChartAuxiliaryService } from "@main/reporting.v3/widget.chart/api/widget-chart-auxiliary.service";


@NgModule({
    declarations: [
        WidgetChartComponent,
        WidgetChartBuilderComponent,
    ],
    providers: [
        WidgetChartPdfExportingService,
        WidgetChartAuxiliaryService,
        WidgetChartService
    ],
    exports: [
        WidgetChartComponent,
        WidgetChartBuilderComponent
    ],
    imports: [
        GridModule,
        ChartModule,
        CommonModule,
        PrimeNgModule,
        ColorPickerModule,

        JsonEditorModule,
        QueryBuilderModule,
        ReportingCoreModule,
    ]
})
export class WidgetChartModule {
}